











import Vue from 'vue'
import HomeLayout from '@/UI/Home/HomeLayout.vue'
import { NewDTO } from '@/Application/News/NewDTO'
import { FetchNewsCommandHandlerProvider } from '@/Infrastructure/News/Provider/FetchNewsCommandHandlerProvider'
import { FetchNewsCommand } from '@/Application/News/FetchNewsCommand'
import { EventBus } from '@/Infrastructure/EventBus/EventBus'
import { i18n } from '@/Infrastructure/Intl/Intl'

export default Vue.extend({
  name: 'Home',
  components: { HomeLayout },
  data () {
    return {
      errorLoading: false,
      loading: false,
      novas: [] as NewDTO[]
    }
  },
  created () {
    this.loadBatches()
  },
  methods: {
    loadBatches (): void {
      EventBus.$emit('loading', true)
      this.errorLoading = false
      this.loading = true
      const provider = new FetchNewsCommandHandlerProvider()
      const command = new FetchNewsCommand(i18n.locale)
      const handler = provider.provide()
      handler.handle(command)
        .then((response: NewDTO[]) => {
          this.novas = response
        })
        .catch(() => {
          this.errorLoading = true
        })
        .finally(() => {
          EventBus.$emit('loading', false)
          this.loading = false
        })
    }
  }
})
